import {
  GetEmailGatewayData,
  getEmailGateway,
  deleteList,
  DeleteList,
  getBizAreaList,
  stopTask,
  getTaskDetailUseCaseStatus,
  getTaskDetailUseCaseCount,
  getTaskDetail,
  getGroupList,
  deleteTask,
  getTaskExecList,
  TaskListProps,
  getResultList,
  getSecurityDeviceList,
  getSecurityTarget,
  getTaskDetailTemplateList,
  getTaskDetailCaseList,
  getTaskDetailCaseAttackType,
  getTaskBaseInfo,
} from '@/api/email-list-task'
import { ChangeJobStatus, changeJobStatus } from '@/api/email-plans-task'
import { testTask } from '@/api/email/email'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'

interface UseGetEmailGatewayDataProps {
  getEmailGatewayDataParams: GetEmailGatewayData
}
export const useGetEmailgatewayData = (props: UseGetEmailGatewayDataProps) => {
  const { getEmailGatewayDataParams } = props
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getEmailGateway(getEmailGatewayDataParams), {
    refreshDeps: [getEmailGatewayDataParams],
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务列表失败'))
    },
  })

  return [run, data?.data, loading] as const
}
// 删除列表
export const useDeleteList = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteList) => deleteList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除列表失败'))
    },
  })
  return [run, loading] as const
}
//
export const useGetBizAreaList = () => {
  const { runAsync: run, data } = useRequest(() => getBizAreaList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全域失败'))
    },
  })
  return [data?.data?.areas || [], run] as const
}

// 停止任务
export const useStopTask = () => {
  const { runAsync: run } = useRequest(data => stopTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务停止失败'))
    },
  })
  return [run] as const
}

// 任务复测
export const useReTestTask = () => {
  const { runAsync: run, loading } = useRequest(data => testTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务复测失败'))
    },
  })
  return [run, loading] as const
}

// 获取任务详情用例状态列表
export const useGetTaskDetailUseCaseStatus = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailUseCaseStatus(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取例状态列表失败'))
    },
  })
  return [run, data?.data?.list || []] as const
}

// 任务结果 根据用例状态统计用例数
export const useGetTaskDetailUseCaseCount = () => {
  const { runAsync: run } = useRequest(params => getTaskDetailUseCaseCount(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取例状态列表失败'))
    },
  })
  return [run] as const
}

// 获取任务详情
export const useGetTaskDetail = () => {
  const { runAsync: run } = useRequest((id: string) => getTaskDetail(id, {}), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务详情失败'))
    },
  })

  return [run] as const
}

// 获取分组列表 (筛选)
export const useGetGroupList = () => {
  const { runAsync: run, data } = useRequest((params: any) => getGroupList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取分组列表失败'))
    },
  })

  return [run, data?.data?.groups || []] as const
}

// 主任务删除
export const useDeleteTask = () => {
  const { runAsync: run, loading } = useRequest((taskIds: string[]) => deleteTask(taskIds), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除任务失败'))
    },
  })

  return [run, loading] as const
}

// 子任务列表
export const useGetTaskExecList = () => {
  const {
    runAsync: run,
    loading,
    data,
  } = useRequest((id: string, params: TaskListProps) => getTaskExecList(id, params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务执行列表失败'))
    },
  })

  return [run, loading, data?.data?.items || []] as const
}

// 获取任务列表
export const useGetTaskList = () => {
  const { runAsync: run, loading } = useRequest((params: TaskListProps) => getResultList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务列表失败'))
    },
  })

  return [run, loading] as const
}

// 任务详情关联模板列表
export const useGetTaskDetailTemplateList = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskDetailTemplateList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取关联模板列表失败'))
    },
  })

  return [run, loading] as const
}

// 任务详情关联模板获取用例列表
export const useGetTaskDetailCaseList = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskDetailCaseList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取关联模板用例列表失败'))
    },
  })

  return [run, loading] as const
}

// 关联模板用例的攻击类型筛选
export const useGetTaskDetailCaseAttackType = () => {
  const { data, runAsync: run } = useRequest(params => getTaskDetailCaseAttackType(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取关联模板用例攻击类型失败'))
    },
  })

  return [data?.data?.list || [], run] as const
}

// 获取安全设备列表 (筛选)
export const useGetSecurityDeviceList = () => {
  const { runAsync: run, data } = useRequest(() => getSecurityDeviceList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全设备列表失败'))
    },
  })

  return [run, data?.data?.devices || []] as const
}

// 获取目标主体 (筛选)
export const useGetSecurityTarget = () => {
  const { runAsync: run, data } = useRequest(() => getSecurityTarget(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取目标主体失败'))
    },
  })
  return [run, data?.data?.targets || []] as const
}

// 获取任务基础信息
export const useGetTaskBaseInfo = () => {
  const { runAsync: run, data } = useRequest((id: string) => getTaskBaseInfo(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务基础信息失败'))
    },
  })

  return [run, data?.data || []] as const
}

// 暂停/重启计划任务
export const useChangeJobStatus = () => {
  const { runAsync: run } = useRequest((params: ChangeJobStatus) => changeJobStatus(params), {
    manual: true,
    onError(err: any) {
      // Message.error(err?.msg || '暂停/重启计划任务')
    },
  })

  return [run] as const
}
